import React from 'react';
import { useDispatch } from 'react-redux';
import { searchFacetChange } from '../Actions/FacetedSearch.action';
import { translate } from '../Services/translation';

export function FilterTags({ facetFilters, navigationTheme }) {
  const dispatch = useDispatch();

  const selectedFacetGroup = facetFilters?.filter(
    (filter) => filter.selectedOptions.length > 0
  );
  const selectedFacetOption = selectedFacetGroup?.reduce((acc, group) => {
    if (!group) {
      return acc;
    }

    const { options, selectedOptions } = group;
    const groupOptions = options
      .filter((option) => selectedOptions.includes(option.id))
      .map((option) => ({ ...option, group }));

    return [...acc, ...groupOptions];
  }, []);

  if (!selectedFacetGroup?.length) {
    return null;
  }

  return (
    <div className="selected-filter">
      <span>{translate('search.yourfilter')} :</span>
      <div>
        {selectedFacetGroup?.map((group, idx) => (
          <span
            key={`group-${idx}`}
            onClick={() => dispatch(searchFacetChange(group))}
            className="selected-filter__tag"
          >
            {' '}
            {group.label}{' '}
          </span>
        ))}
      </div>
    </div>
  );
}

export default FilterTags;
